import styled from 'styled-components';
import { WALLET_DETAIL_BG } from '../../config/constants';

const Wrapper = styled.div`
	position: absolute;
	left: 0%;
	top: 0;
	width: 100%;
	height: 100%;
	.spin-wrapper {
		position: absolute;
		z-index: 200;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(200, 200, 200, 0.5);
		> * {
			position: absolute;
			left: 45%;
			top: 45%;
		}
	}
	.holla-wallet-header {
		padding: 28px 46px;
		margin-bottom: 70px;
		min-height: 241px;
		position: relative;
		background-color: #000;
		background-image: url(${WALLET_DETAIL_BG});
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		color: #fff;
		.header-title {
			font-size: 48px;
			color: #fff;
			vertical-align: middle;
			font-family: HaasGrotDisp, -apple-system, system-ui;
		}
		.ant-input-group-wrapper {
			vertical-align: middle;
			width: auto;
			margin-left: 8px;
			min-width: 460px;
		}

		.holla-crumb {
			position: absolute;
			left: 28px;
			top: 4px;
			a {
				color: #0000ff;
			}
		}
		.coin-wrapper {
			display: flex;
			align-items: top;
		}
		.label {
			text-align: top;
			padding: 2px 4px;
			border-radius: 2px;
			display: block;
			height: 22px;
			font-size: 12px;
			margin-left: 8px;
			&.testnet {
				background-color: #e9e9e9;
				color: #000;
			}
			&.mainnet {
				background-color: green;
				color: #fff;
			}
		}
		.settings-wrap {
			max-width: 120px;
			position: absolute;
			right: 46px;
			top: 25px;

			.ant-btn-info {
				background-color: transparent;
				border-color: #fff;
				color: #fff;
			}
		}
		.webhook-wrap {
			position: absolute;
			left: 46px;
			bottom: -39px;
			cursor: pointer;
			text-align: center;
			.box {
				border: 1px solid #0000ff;
				padding: 12px;
				box-sizing: content-box;
				height: 78px;
				width: 78px;
				background-color: #fff;
			}
			.multi-address-info {
				position: relative;
				bottom: 75px;
				left: 0;
				white-space: nowrap;
				p {
					position: static;
					color: #fff;
					font-size: 16px;
					span {
						color: #00f;
						font-size: 16px;
						line-height: 1;
						text-decoration: underline;
					}
				}
			}
			span {
				color: #00f;
				font-size: 46px;
				line-height: 78px;
			}
			p {
				color: #808083;
				position: absolute;
				left: 115px;
				bottom: 0;
				font-size: 10px;
				text-align: left;
				line-height: 1;
				width: 300px;
				margin: 8px 0;
			}
		}
		.deposit-address {
			padding-top: 42px;
			text-align: right;
		}
		.coin-name {
			color: #fff;
		}
		p {
			margin-top: 12px;
		}
		.edit-btn {
			color: #0000ff;
			cursor: pointer;
			text-decoration: underline;
		}
		.btn-wrapper {
			position: absolute;
			right: 46px;
			top: 70px;
			max-width: 440px;
			display: flex;
			.btn-center {
				margin: 0 4px;
			}
			.ant-btn {
				font-size: 22px;
			}
			.ant-btn-info {
				background-color: transparent;
				border-color: #fff;
				color: #fff;
			}
			&.multi {
				max-width: 550px;
				top: initial;
				bottom: 30px;
				.ant-btn {
					font-size: 14px;
				}
			}
		}
		.ant-btn-danger {
			position: absolute;
			right: 46px;
			bottom: -42px;
		}
	}

	.wallet-container {
		margin: 22px;

		border-top: 1.5px solid #393939;

		.ant-tabs-bar {
			margin: 0;
		}
	}
	.filter-wrapper {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.holla-table-filter-container {
		display: flex;
		justify-content: flex-start;
		margin-top: 8px;
		margin-bottom: 8px;
		.ant-select {
			min-width: 160px;
			max-width: 160px;
			.ant-select-selection {
				border-radius: 0;
			}
		}
		.ant-input-affix-wrapper {
			min-width: 200px;
			max-width: 200px;
			.ant-input {
				border-radius: 0;
			}
		}
		.ant-calendar-picker-input.ant-input {
			border-radius: 0;
		}
	}

	@media (max-width: 1200px) {
		padding-bottom: 30px;
		.holla-wallet-header {
			padding: 16px;
			.header-title {
				font-size: 24px;
			}
			.holla-crumb {
				position: static;
				padding: 4px 0;
			}
			.coin-name {
				color: #fff;
			}
			p {
				margin-top: 12px;
			}
			.edit-btn {
				color: #0000ff;
				cursor: pointer;
				text-decoration: underline;
			}
			.ant-input-group-wrapper {
				min-width: 320px;
			}
			.btn-wrapper {
				width: 100%;
				max-width: none;
				position: static;
				flex-direction: column;
				.btn-center {
					margin: 4px 0;
				}
				&.multi {
					width: 100%;
					max-width: none;
				}
			}
			.webhook-wrap {
				position: static;
				p {
					position: static;
					text-align: center;
					width: 100%;
				}
				.multi-address-info {
					position: static;
				}
				.box {
					margin: 12px auto;
				}
			}
			.deposit-address {
				padding-top: 12px;
				padding-bottom: 12px;
				text-align: left;
			}
		}
		.holla-table-filter-container {
			flex-direction: column;
			.ant-select {
				max-width: 100%;
			}
			.ant-input-affix-wrapper {
				max-width: 100%;
			}
		}
		.filter-wrapper {
			flex-direction: column;
			align-items: unset;
		}
		.flex-box {
			.btn-wrapper {
				max-width: none;
				position: fixed;
				justify-content: space-between;
				left: 12px;
				right: 12px;
				bottom: 12px;
				z-index: 10;
			}
		}
	}
`;

export const SearchTransactionWrapper = styled.div`
	h2 {
		padding: 12px 0;
		&.center {
			text-align: center;
		}
	}
	.status {
		font-size: 12px;
		margin-bottom: 4px;
		b {
			padding-right: 5px;
		}
	}
	> div {
		padding-top: 12px;
		p {
			margin-bottom: 0;
		}
	}
	.btn-area {
		display: flex;
		> button {
			flex: 1;
			margin-right: 12px;
		}
		.ant-btn-primary {
			flex: 2;
			margin-right: 0;
		}
	}
`;

export const SettingsWrapper = styled.div`
	padding-top: 1rem;

	.settings-sweep {
		display: flex;
		align-items: center;
		margin-top: 1rem;

		.ant-switch {
			height: 26px;
			&::after {
				background-color: #000000;
				top: 2px;
				left: 2px;
				height: 20px;
				width: 20px;
			}
		}
		.ant-switch-checked {
			&::after {
				background-color: #ffffff;
				top: 2px;
				left: 100%;
				margin-left: -2px;
				height: 20px;
				width: 20px;
			}
		}
		.switch-text {
			margin-right: 3px;
			margin-bottom: 0px;
			background-color: #ffffff;
			color: #B3B3B3;
			z-index: 1;
		}
		.switch-text-active {
			color: #000000 ;
			font-weight: bold;
		}

		.sweep-description {
			max-width: 220px;
			font-size: 10px;
			border: 1px solid #CCCCCC;
			border-radius: 13px;
			padding: 0.75rem 1.25rem;
			position: relative;
			right: 8px;
		}
	}
	.settings-btn {
		margin: 1rem 0px;
		width: 200px;
	}
`;

export default Wrapper;
